import { createRouter, createWebHistory } from "vue-router";
//import Home from "../views/Home.vue";
import LogIn from "../views/LogIn.vue";
import LogOut from "../views/LogOut.vue";

const routes = [
    {
        path: "/",
        name: "FrontPage",
        component:  () => import("../views/FrontPage.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/dashboard",
        name: "DashBoard",
        component:  () => import("../views/Dashboard.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/login",
        name: "Login",
        component: LogIn,
    },

    {
        path: "/logout",
        name: "LogOut",
        component: LogOut,
    },

    {
        path: "/inbox",
        name: "InBox",
        component:  () => import("../views/Inbox.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
      path: "/newsfeed",
      name: "NewsFeed",
      component:  () => import("../views/NewsFeed.vue"),
      meta:{
        requiresAuth: true
      }
    },

    {
        path: "/sales",
        name: "Sales",
        component:  () => import(/* webpackChunkName: "calendar" */ "../views/Sales.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/drm",
        name: "DRM",
        component:  () => import(/* webpackChunkName: "crm" */ "../views/DRM.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/drm/:id",
        name: "Dealer",
        props: true,
        component:  () => import(/* webpackChunkName: "crm" */ "../views/DRM.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/drm/:id/:tab",
        name: "DealerTab",
        props: true,
        component:  () => import(/* webpackChunkName: "crm" */ "../views/DRM.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/crm",
        name: "Crm",
        component:  () => import(/* webpackChunkName: "crm" */ "../views/CRM.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/crm/:id",
        name: "Customers",
        props: true,
        component:  () => import(/* webpackChunkName: "crm" */ "../views/CRM.vue"),
        meta:{
            requiresAuth: false
        }
    },

    {
        path: "/crm/:id/order/:orderListId",
        name: "OrderList",
        props: true,
        component:  () => import(/* webpackChunkName: "crm" */ "../views/CRM.vue"),
        meta:{
            requiresAuth: true
        }
    },

  {
        path: "/ProfilingProducts",
        name: "ProfilingProducts",
        props: true,
        component:  () => import( "../views/Order/ProfilingProducts.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/Backorders",
        name: "Backorders",
        props: true,
        component:  () => import( "../views/Order/BackordersMain.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/party/:id",
        name: "PartyView",
        props: true,
        component:  () => import(/* webpackChunkName: "crm" */ "../views/Party/PartyView.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/party/:id/custlist/:custListId",
        name: "PartyCustomer",
        props: true,
        component:  () => import(/* webpackChunkName: "crm" */ "../views/Party/PartyView.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/calendar",
        name: "CalendarPage",
        component:  () => import(/* webpackChunkName: "calendar" */ "../views/CalendarPage.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/order",
        name: "Order",
        component:  () => import(/* webpackChunkName: "order" */ "../views/Order/OrderView.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/order/:id",
        name: "OrderDetail",
        props:true,
        component:  () => import(/* webpackChunkName: "order" */ "../views/Order/OrderView.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/order-history",
        name: "OrderHistory",
        component:  () => import(/* webpackChunkName: "order" */ "../views/Order/OrderHistory.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/invoice-history",
        name: "InvoiceHistory",
        component:  () => import(/* webpackChunkName: "order" */ "../views/InvoiceHistory.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/returns-overview",
        name: "ReturnsOverview",
        component:  () => import(/* webpackChunkName: "order" */ "../views/Returns/ReturnsOverview.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
      path: "/return-detail/:id",
      name: "ReturnDetail",
      props:true,
      component:  () => import(/* webpackChunkName: "return" */ "../views/Returns/ReturnDetail.vue"),
      meta:{
        requiresAuth: true
      }
    },

    {
        path: "/products",
        name: "ProductList",
        component:  () => import(/* webpackChunkName: "product" */ "../views/ProductList.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/results",
        name: "MyResults",
        component:  () => import(/* webpackChunkName: "result" */ "../views/Results/ResultsMain.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/campaigns",
        name: "Campaigns",
        component:  () => import(/* webpackChunkName: "result" */ "../views/Results/CampaignsMain.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/democampaigns",
        name: "DemoCampaigns",
        component:  () => import(/* webpackChunkName: "result" */ "../views/Results/DemoCampaigns.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/leaderboards",
        name: "Leaderboards",
        component:  () => import(/* webpackChunkName: "result" */ "../views/Results/Leaderboards.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/kickback",
        name: "KickbackMain",
        component:  () => import(/* webpackChunkName: "result" */ "../views/Results/KickbackMain.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/groupmember/:id",
        name: "GroupMember",
        props: true,
        component:  () => import(/* webpackChunkName: "team" */ "../views/Groupmember/GroupMember.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/team",
        name: "TeamSales",
        component:  () => import(/* webpackChunkName: "team" */ "../views/Team/TeamSales.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
      path: "/teaminsight/:week/:artno/",
      name: "TeamInsight",
      component:  () => import(/* webpackChunkName: "team" */ "../views/Team/TeamInsight.vue"),
      meta:{
        requiresAuth: true
      }
    },
    {
        path: "/teamrecruits",
        name: "TeamRecruits",
        component:  () => import(/* webpackChunkName: "team" */ "../views/Team/TeamRecruits.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/teamleader",
        name: "TeamKickback",
        component:  () => import(/* webpackChunkName: "team" */ "../views/Team/TeamKickback.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/teamsettings",
        name: "TeamSettings",
        component:  () => import(/* webpackChunkName: "team" */ "../views/Team/TeamSettings.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/admin",
        name: "AdminMain",
        component:  () => import(/* webpackChunkName: "admin" */ "../views/Admin/AdminMain.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/adminprofiles",
        name: "ProfileAdmin",
        component:  () => import(/* webpackChunkName: "admin" */ "../views/Admin/AdminProfiles.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/adminreturns",
        name: "AdminClaims",
        component:  () => import(/* webpackChunkName: "admin" */ "../views/Admin/Claim/AdminClaims.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/adminprocessclaim",
        name: "AdminProcessClaim",
        component:  () => import(/* webpackChunkName: "admin" */ "../views/Returns/AdminProcessClaim.vue"),
        meta:{
            requiresAuth: true
        }
    },

    {
        path: "/adminapprove/:id",
        name: "AdminApproveProfile",
        component:  () => import(/* webpackChunkName: "admin" */ "../views/Admin/AdminApproveProfile.vue"),
        props: true,
        meta:{
          requiresAuth: true
        }
    },
    {
        path: "/adminViewClaim/:id",
        name: "AdminViewClaim",
        component:  () => import(/* webpackChunkName: "admin" */ "../views/Admin/Claim/ViewClaim.vue"),
        props: true,
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/admineditprofile/:id",
        name: "AdminEditProfile",
        component:  () => import(/* webpackChunkName: "admin" */ "../views/Admin/AdminEditProfile.vue"),
        props: true,
        meta:{
          requiresAuth: true
        }
    },

    {
        path: "/admin/dealers",
        name: "Dealerlist",
        component:  () => import(/* webpackChunkName: "admin" */ "../views/Admin/AdminDealers.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/goals",
        name: "GoalsDisplay",
        component:  () => import(/* webpackChunkName: "goals" */ "../views/Goals.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/product/:sku",
        name: "ProductView",
        props: true,
        component:  () => import(/* webpackChunkName: "products" */ "../views/ProductView.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/post/:id",
        name: "PostView",
        props: true,
        component:  () => import(/* webpackChunkName: "posts" */ "../views/PostView.vue"),
        meta:{
            requiresAuth: true
        }
    },
  {
    path: "/new-claim/list/:custlistid/line/:lineid",
    name: "MakeClaim",
    props: true,
    component:  () => import(/* webpackChunkName: "returns" */ "../views/Returns/MakeClaim.vue"),
    meta:{
      requiresAuth: true
    }
  },
   {
        path: "/claim-status/:claimid",
        name: "EditClaim",
        props: true,
        component:  () => import(/* webpackChunkName: "returns" */ "../views/Returns/EditClaim.vue"),
        meta:{
            requiresAuth: true
        }
    },
  {
    path: "/return-history",
        name: "ReturnHistory",
        props: true,
        component:  () => import(/* webpackChunkName: "posts" */ "../views/Returns/ReturnHistory.vue"),
        meta:{
            requiresAuth: true
        }
    },
    {
        path: "/Me",
        name: "MyDealerView",
        component:  () => import("../views/Me/MyDealerView.vue"),
        meta:{
            requiresAuth: true
        }
    },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
    const isAuthSetUp = !!window.localStorage.getItem('authToken')

    if (requiresAuth && !isAuthSetUp) {
        return next('/login')
    }

    window.scrollTo(0,0);

    return next()
})
export default router;
